module.exports = __webpack_public_path__ + "img/53.974eac44.jpg";